<mat-card class="form-container small">
  <mat-progress-bar
    *ngIf="isLoading"
    mode="indeterminate"
    color="accent">
  </mat-progress-bar>
  <div class="row v-center between">
    <div class="row v-center">
      <mat-icon class="back"
        (click)="back()">arrow_back_ios</mat-icon>
      <ui-divider [vertical]="true"
        [compact]="true"></ui-divider>
      <h3> {{ 'forgot-password-set.title' | translate }} </h3>
    </div>
    <div>
      <span class="">
        <button mat-button
          class="language-selector"
          [matMenuTriggerFor]="langSelector"
          [matTooltip]="'language' | translate">
          {{ selectedLanguage | uppercase }}
          <mat-icon class="transparent">language</mat-icon>
        </button>
        <mat-menu #langSelector="matMenu"
          x-position="after"
          y-position="below">
          <button mat-menu-item
            (click)="changeLanguage('cs')">{{ 'language-cs' | translate }}</button>
          <button mat-menu-item
            (click)="changeLanguage('sk')">{{ 'language-sk' | translate }}</button>
          <button mat-menu-item
            (click)="changeLanguage('en')">{{ 'language-en' | translate }}</button>
        </mat-menu>
      </span>
    </div>
  </div>
  <p>{{ 'forgot-password-set.message'| translate }}</p>
  <ui-divider></ui-divider>
  <form [formGroup]="form"
    class="form">
    <div class="column">
    <ui-password-input [value]="''"
      [placeholder]="'profile.password-new-password'"
      [name]="'newPassword'"
      (onInputChange)="changeFormValue($event.name, $event.value)"></ui-password-input>

    <ui-password-input [value]="''"
      [placeholder]="'profile.password-new-password-confirm'"
      [name]="'newPasswordConfirm'"
      (onInputChange)="changeFormValue($event.name, $event.value)">
    </ui-password-input>

    <p class="error-label centered"
      *ngIf="!!form.value.newPasswordConfirm && !arePasswordsEqual">{{ 'profile.password-match-error' | translate }}</p>
    <p class="error-label centered"
      *ngIf="!!form.value.newPassword && form.value.newPassword.length < 8">
      {{ 'profile.password-format-error' | translate }}</p>

    <ui-divider></ui-divider>
    <button
      mat-button
      mat-raised-button
      [disabled]="isLoading || form.invalid || !arePasswordsEqual"
      color="primary"
      class="main-button"
      (click)="setPassword()">
      {{ 'profile.change-password' | translate }}
    </button>
  </div>
  </form>
</mat-card>
